import { useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { api } from "@/lib/api";

// Owner switch: hide the Queue so assistants only work from batches.
export default function HideQueueToggle({ initial, onChanged }) {
  const [on, setOn] = useState(!!initial);
  const change = async (v) => {
    setOn(v);
    try {
      await api.put("/team/queue-setting", { hide_queue: v });
      toast.success(v ? "Queue hidden for every assistant" : "Queue is back for every assistant");
      onChanged?.();
    } catch {
      setOn(!v);
      toast.error("Couldn't save that");
    }
  };
  return (
    <label className="mt-4 flex items-start justify-between gap-3 rounded-lg border border-slate-200 bg-slate-50 p-3" data-testid="team-hide-queue">
      <span className="min-w-0">
        <span className="block text-sm font-semibold text-slate-900">Hide the Queue for everyone</span>
        <span className="block text-[11px] text-slate-500">{on ? "Assistants only see batches. Turn it on or off for one person on their row below." : "Off: assistants can use the Queue. Hide it for one person on their row below."}</span>
      </span>
      <Switch checked={on} onCheckedChange={change} data-testid="team-hide-queue-switch" />
    </label>
  );
}
